import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/download";

export const ChatSheet = ({ target, onClose }) => {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);
  const id = target?.id;
  useEffect(() => {
    if (!id) { return undefined; }
    setText(target.prefill || "");
    const load = () => api.get(`/messages/${id}`).then((r) => setMsgs(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) { return; }
    setBusy(true);
    try { await api.post("/messages", { toUserId: id, body: text.trim() }); setText(""); setMsgs((await api.get(`/messages/${id}`)).data); toast.success("Messaggio inviato"); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <Sheet open={!!target} onOpenChange={(o) => { if (!o) { onClose(); } }}>
      <SheetContent side="right" className="w-full sm:max-w-md flex flex-col p-0" data-testid="proposal-chat-sheet">
        <SheetHeader className="p-5 border-b border-slate-100 text-left">
          <SheetTitle className="font-display text-xl text-aic-navy" data-testid="proposal-chat-title">Chat con {target?.name}</SheetTitle>
          <SheetDescription>{target?.macro}{target?.note ? ` · ${target.note}` : ""}</SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-5 space-y-3 bg-[#F5F7FB]" data-testid="proposal-chat-messages">
          {msgs.length === 0 && <p className="text-sm text-slate-500 text-center mt-6">Nessun messaggio ancora: scrivi tu il primo.</p>}
          {msgs.map((m) => (
            <div key={m.id} className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm whitespace-pre-line ${m.fromUserId === user.id ? "ml-auto bg-aic-navy text-white" : "bg-white border border-slate-200"}`} data-testid="proposal-chat-message">{m.body}</div>
          ))}
          <div ref={endRef}/>
        </div>
        <form onSubmit={send} className="p-4 border-t border-slate-100 space-y-2">
          <textarea rows={4} maxLength={4000} value={text} onChange={(e) => setText(e.target.value)} data-testid="proposal-chat-input" className="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-gold"/>
          <button disabled={busy || !text.trim()} data-testid="proposal-chat-send" className="btn-pill-gold text-sm w-full justify-center disabled:opacity-50"><Send className="w-4 h-4"/>{busy ? "Invio…" : "Invia messaggio"}</button>
        </form>
      </SheetContent>
    </Sheet>
  );
};
